import React, { useEffect, useState } from "react";
import "./GoGreenSection.css";
import {
  policyIcon,
  treeWithLeaf,
  treeWithoutLeaf,
} from "../../../images/btnIcons";
import LanguageTranslater from "../../HOC/LanguageTranslater";

const GoGreenSection = ({ goGreenFlag, handleGoGreenCheckbox, translate }) => {
  const isGoGreenOpted = goGreenFlag === "Y";
  const [cntnrHeight, setCntnrHeight] = useState(192)

  const generateMinHeightForConatiner = () => {
    const goGreenContainer = document.querySelector(".go-green-cntnr")
    const requiredHeight = goGreenContainer.clientHeight + 16
    setCntnrHeight(requiredHeight)
  }

  useEffect(() => {
    generateMinHeightForConatiner()
  }, [])

  const handleToggle = () => {
    const tE = { target: { checked: false } };
    if (isGoGreenOpted) {
      tE.target.checked = false;
    } else {
      tE.target.checked = true;
    }
    handleGoGreenCheckbox(tE);
  };


  return (
    <div className="go-green-section" style={{
      minHeight: cntnrHeight
    }}>
      <div
        className={
          isGoGreenOpted ? "go-green-cntnr" : "go-green-cntnr gg-not-opted"
        }
      >
        <div className="go-green-header">
          <p>{translate('go_green_line_1')}</p>
        </div>
        <div className="go-green-main-txt-cntnr">
          <p className="go-green-main-txt">
            {translate('go_green_line_2')}
          </p>
          <img
            src={isGoGreenOpted ? treeWithLeaf : treeWithoutLeaf}
            alt="treeIcn"
          />
        </div>
        <div className="go-green-bottom-txt">
          {translate('go_green_line_3')}
        </div>
        <div className="go-green-footer">
          <p>
            <img src={policyIcon} alt="policy_icn" />{" "}
            <span>{translate('go_green_line_4')}</span>
          </p>
          <div className="toogle-icn-cntnr">
            <div
              onClick={handleToggle}
              className={
                isGoGreenOpted ? "tggle-trk not-active" : "tggle-trk active"
              }
            >
              <div className="tggle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageTranslater(GoGreenSection);
